import React, { useEffect } from "react";
import "@/animations/animate.css";

import Image from "next/image";
import AnimatedElements from "@/animations/AnimatedElement";

import { motion, useScroll, useSpring, useTransform } from 'framer-motion';
import AnimatedBody from "@/animations/AnimatedBody";

const HavaDurumu = ({certificate } : any ) => {
const ref = React.useRef(null)
const { scrollYProgress } = useScroll({
target: ref,
offset: ["start end", "100vh"]

})

const transform = useTransform(
scrollYProgress,
[0, 1],
[0,2]
)

const y = useTransform(scrollYProgress, [0, 1], [0, -400]);
const y1 = useTransform(scrollYProgress, [0, 1], [0, -250]);
const y2 = useTransform(scrollYProgress, [0, 1], [0, -150]);

const physics = { damping: 15, mass: 0.27, stiffness: 55 }
const scale = useSpring(transform, physics)
const [result, setResult] = React.useState<any>(null);
const [load , setLoad] = React.useState(false);
useEffect(() => {

    async function getdata() {
   
        
        const havadurumu = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/hava?certificate=${certificate}`);
        const havadurumu2 = await havadurumu.json();
        console.log(havadurumu2)
        setLoad(true)
        setResult(havadurumu2)
    }

    getdata();

}
, [])

return (
<>
    <section ref={ref}
        className="relative min-h-screen w-screen z-10 0  items-center justify-center overflow-hidden bg-black bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
        id="weather">
{load &&(

        <div className="mx-auto flex w-screen flex-row items-center justify-center ">

            <div className="mx-auto flex w-screen flex-col   lg:gap-20">
                <div
                    className="mb-10 flex w-screen   flex-col  items-center justify-center  text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7] md:mb-16  md:text-[20px] md:leading-relaxed lg:mb-16   lg:text-[24px] ">
                    <motion.div style={ { scale } }>
                        <AnimatedElements>
                            <Image src={`https://sertfika.vercel.app/weather/${result.icon}`} alt="hava durumu"
                                className="rounded-3xl z-1" width={300} height={300} />
                        </AnimatedElements>
                    </motion.div>
                </div>                           
                
                <div className="flex flex-col z-30 shadow-md  drop-shadow-md  shadow-black gap-2 w-screen p-10">
                <motion.div style={ { y } } className="w-full  text-center justify-center">
                    <AnimatedBody delay={0.2}
                        className="text-3xl sm:text-3xl  font-semibold text-center !text-opacity-100 !text-white-vibrant w-full"
                        text={`${result.text2} `} />
                </motion.div>
                <motion.div style={ { y : y1 } } className="w-full text-center justify-center">
            
<AnimatedBody delay={0.4}
                        className="text-[1.5rem] sm:text-[1.9rem] font-semibold text-center !text-opacity-100 !text-white-vibrant w-full"
                        text={`${result.text3} `} />
                </motion.div>
                <motion.div className="w-full text-center justify-center" style={ { y : y2 } }>
                    <AnimatedBody delay={0.6}
                        className="text-[1.5rem] sm:text-[1.9rem] font-semibold text-center !text-opacity-100 !text-white-vibrant w-full"
                        text={`${result.text4} `} />
                </motion.div>
                </div>
            </div>
            <div className="mx-auto flex w-[100%] flex-col lg:max-w-[1200px] lg:flex-row lg:gap-20">
                <div
                    className="mb-10 flex w-[100%] flex-col gap-4 text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7] md:mb-16 md:gap-6 md:text-[20px] md:leading-relaxed lg:mb-16  lg:max-w-[90%] lg:text-[24px] ">

                </div>
            </div>
        </div>    )}

    </section>
</>
);
};

export default HavaDurumu;